// src/lib/hashtag.ts

/**
 * Canonical tag slug used for links: lowercase, words joined by a single
 * hyphen. `_`, whitespace and ZWNJ are separators, so a slug never contains
 * `_`. The visible hashtag text in the caption is never altered.
 *
 * "#salam_bar_to" → "salam-bar-to"
 */
export function hashtagToSlug(raw: string): string {
    return raw
        .replace(/^#/, "")
        .trim()
        .toLowerCase()
        .replace(/[\s_‌‍-]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

export function hashtagToHref(
    raw: string,
    hrefPrefix = "/timeline",
): string {
    const slug = hashtagToSlug(raw);
    return `${hrefPrefix}?tag=${encodeURIComponent(slug)}`;
}
